import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-white border-t text-sm text-gray-500 px-6 py-4 flex flex-col md:flex-row justify-between items-center mt-auto">
      <p className="mb-2 md:mb-0">&copy; {new Date().getFullYear()} Noltrade. Todos los derechos reservados.</p>
      <div className="flex gap-4">
        <Link to="/legal/privacidad" className="hover:underline">Privacidad</Link>
        <Link to="/legal/cookies" className="hover:underline">Cookies</Link>
        <Link to="/legal/aviso" className="hover:underline">Aviso legal</Link>
      </div>
    </footer>
  );
}
